module.exports = __webpack_public_path__ + "img/bj_zuoda_yao@2x.59cb0185.png";